import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import { FacebookShareButton, TwitterShareButton, WhatsappShareButton } from 'react-share'
import FacebookIcon from '@material-ui/icons/Facebook'
import TwitterIcon from '@material-ui/icons/Twitter'
import WhatsAppIcon from '@material-ui/icons/WhatsApp'
import Button from '@material-ui/core/Button'
import Hidden from '@material-ui/core/Hidden';

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1
	},
	menuButton: {
		marginRight: theme.spacing(2)
	},
	title: {
		flexGrow: 1,
		color: '#e93f3e',
		fontWeight: 'bolder'
	},
	item: {
		flexGrow: 1,
		color: '#383838'
	},
	bar: {
		backgroundColor: 'transparent',
		boxShadow: 'none'
	}
}))

export default function ButtonAppBar() {
	const classes = useStyles()

	return (
		<div className={classes.root}>
			<AppBar position="static" className={classes.bar}>
				<Toolbar>
					<Typography variant="h6" className={classes.title}>
						Vigila Perú Covid-19
					</Typography>
					<Hidden xsDown>
						<div className={classes.item}>
							<Button size="small" className={classes.margin} href="#mapa">
								Mapa
							</Button>
							<Button size="small" className={classes.margin} href="#cobertura">
								Cobertura
							</Button>
						</div>
					</Hidden>

					<div style={{ display: 'flex', minWidth: 100, justifyContent: 'space-around' }}>
						<FacebookShareButton url="http://fundacionmohme.org/especiales/vigila-covid-19">
							<FacebookIcon style={{ color: '#e93f3e' }} />
						</FacebookShareButton>
						<TwitterShareButton url="http://fundacionmohme.org/especiales/vigila-covid-19">
							<TwitterIcon style={{ color: '#e93f3e' }} />
						</TwitterShareButton>
						<WhatsappShareButton url="http://fundacionmohme.org/especiales/vigila-covid-19">
							<WhatsAppIcon style={{ color: '#e93f3e' }} />
						</WhatsappShareButton>
					</div>
				</Toolbar>
			</AppBar>
		</div>
	)
}
